module.exports = __webpack_public_path__ + "assets/OctagonBySide.bfc9741db3d9676aba5af106b73ec8ee.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/OctagonBySide.gmt
// module id = 974
// module chunks = 0